import { SafeHtml } from "@angular/platform-browser";
import { ModifiedActionStatus, VENDOR_TYPE } from "../enums";

export interface VendorList {
  account_last_fourdigit: string;
  account_name: string;
  account_number: string;
  account_type: string;
  additional_information: string;
  bank_detail_id: string;
  bank_name: string;
  bank_country: string;
  branch_code: string;
  city: string;
  company: string;
  company_name: string;
  company_registration_number: string;
  company_type: string;
  company_type_name: string;
  country: string;
  createdOn: Date | string;
  currency: string;
  customer_id: string;
  designation: string;
  document: string;
  email: string;
  first_name: string;
  iban_number: string;
  last_name: string;
  mobile_number: string;
  quotations: QuotationList[];
  invoices: InvoiceListing[];
  routing_number: string;
  state: string;
  street1: string;
  street2: string;
  swift_code: string;
  user_id: string;
  vat_registration: string;
  vendor_id: string;
  vendor_individual_id: string;
  vendor_type: VENDOR_TYPE | string;
  vendor_type_id: string;
  vendor_type_name: string;
  vendor_typename: string;
  zipcode: string;
  profilepicture: string;
}

export interface InvoiceListing {
  company_name: string;
  createdOn: string | Date;
  first_name: string;
  invoice_amount: string;
  invoice_doc: string;
  invoice_id: string;
  invoice_status: string;
  invoice_uniqueid: string;
  last_name: string;
  mobile_number: string;
  order_id: string;
  quotation_id: string;
  service_description: string;
  service_type: string;
  tax: string;
  status: ModifiedActionStatus;
  vendor_name: string;
}

export interface CreateVendor {
  vendor_type: VENDOR_TYPE;
  first_name: string;
  last_name: string;
  mobile_number: string;
  email: string;
  street1: string;
  country: string;
  state: string;
  city: string;
  zipcode: string;
  uploadId: File | string;
  bank_account_name: string;
  account_no: string;
  bank_name: string;
  bank_country: string;
  currency: string;
  branch_code: string;
  routing_no: string;
  swift_code: string;
  iban_no: string;
  account_type: string;
  additional_info: string;

  company: string; //incase of individual vendor
  vendor_type_id: VendorTypeList; //incase of individual vendor

  company_name: string; //incase of company
  company_registration_number: string; //incase of company
  company_type: VendorTypeList; //incase of company
  vat_registration: string; //incase of company
  designation: string; //incase of company
}

export interface VendorTypeList {
  created_on: Date | string;
  customer_id: string;
  user_id: string;
  vendor_type: string;
  vendor_type_id: string;
  vendor_type_status: string;
}

export interface ChangeQuotationStatus {
  quotation_id: string;
  vendor_id: string;
  quotation_status: string;
  quotation_comment: string;
  uploadId: string;
}

export interface AssignJobToVendor {
  quotation_id: string;
  quotation_status: string;
  vendor_id: string;
}

export interface QuotationList {
  assign_status: string;
  client_name: string;
  company_name: string;
  customer_id: string;
  expected_delivery: Date | string;
  mobile_number: string;
  order_id: string;
  po_document: string;
  quoatation_status: string;
  quoatation_status_value: string;
  quotation_comment: string;
  quotation_id: string;
  requirement_document: string;
  sent_on: string | Date;
  user_id: string;
  vendor_id: string;
  vendor_reason: string;
  vendor_type: string;
  vendor_type_id: string;
  vendor_firstname: string;
  vendor_lastname: string;
  status: ModifiedActionStatus;
}

export interface RateVendor {
  vendor_id: string;
  vendor_type: string;
  charges_rating: string;
  quality_of_services_rating: string;
  responsiveness_rating: string;
  professionalism_rating: string;
  charges_comment: string;
  quality_of_services_comment: string;
  responsiveness_comment: string;
  professionalism_comment: string;
}

export interface ListVendorRating {
  company_name: string;
  created_on: string | Date;
  rating: number | SafeHtml;
  servive_opted: string;
  vendor_id: string;
  vendor_rating_id: string;
}
export interface ViewVendorRating {
  charges_comment: string;
  charges_rating: number;
  company_name: string;
  created_on: string | Date;
  customer_id: string;
  first_name: string;
  last_name: string;
  professionalism_comment: string;
  professionalism_rating: number;
  quality_of_services_comment: string;
  quality_of_services_rating: number;
  rating: number;
  responsiveness_comment: string;
  responsiveness_rating: number;
  servive_opted: string;
  user_id: string;
  vendor_id: string;
  vendor_rating_id: string | number;
  vendor_type: string;
}

export interface vendorReports {
  vendorcompletedreport: number;
  vendorinprogressreport: number;
  vendorpendingreport: number;
}
export interface RequestForQuotation {
  vendor_id: string;
  vendor_typeid: string;
  quotation_requirement: string;
  expected_delivery: string | Date;
  uploadId: File | string;
}

export interface InvoiceDetail {
  city: string;
  company: string;
  company_name: string;
  company_registration_number: string;
  company_type: string;
  country: string;
  createdOn: string | Date;
  customer_CreatedDate: string | Date;
  customer_address: string;
  customer_company_name: string;
  customer_createdBy: string;
  customer_description: string;
  customer_designation: string;
  customer_email: string;
  customer_id: string;
  customer_name: string;
  customer_phone_no: string;
  customer_site_url: string;
  customer_status: string;
  customer_updatedBy: string;
  customer_updatedDate: string | Date;
  designation: string;
  document: string;
  email: string;
  first_name: string;
  invoice_id: string;
  invoice_uniqueid: string;
  last_name: string;
  mobile_number: string;
  order_id: string;
  state: string;
  status: string;
  street1: string;
  street2: string;
  user_id: string;
  vat_registration: string;
  vendor_id: string;
  vendor_individual_id: string;
  vendor_type: string;
  vendor_type_id: string;
  zipcode: string;
  invoice_amount: number;
  invoice_status: string;
  service_description: string;
  service_type: string;
  submit_status: string;
  tax: number;
  vendor_typename: string;
  total: number | string;
  invoice_doc: string;
}

export interface GenerateInvoice {
  quotation_id: string;
  invoice_id: string;
  service_type: string;
  service_description: string;
  amount: string;
  tax: string;
  invoice_doc?: File | string;
}

export interface GenerateInvoicePdf {
  customer_address: string;
  invoice_uniqueid: string;
  customer_company_name: string;
  customer_phone_no: string;
  order_id: string;
  createdOn: string;
  invoice_issueDate: string;
  company_name: string;
  first_name: string;
  last_name: string;
  mobile_number: string;
  vendor_address: string;
  servicetype_name: string;
  service_description: string;
  invoice_amount: string;
  invoice_tax: string;
  invoice_total: string;
}

export interface ViewVendorProfile {
  profile_picture: any;
  city: string;
  company: string;
  company_name: string;
  company_registration_number: number;
  company_type: string;
  country: string;
  createdOn: string | number;
  customer_id: string | number;
  designation: string;
  document: string;
  email: string;
  first_name: string;
  last_name: string;
  mobile_number: string | number;
  profilePicture: string;
  state: string;
  status: string;
  street1: string;
  street2: string | number;
  user_id: string;
  vat_registration: string | number;
  vendor_individual_id: string;
  vendor_type: string;
  vendor_type_id: string;
  zipcode: string | number;
  account_last_fourdigit: string;
  account_name: string;
  account_number: string;
  account_type: string;
  additional_information: string;
  bank_country: string;
  bank_detail_id: string;
  bank_name: string;
  branch_code: string;
  currency: string;
  iban_number: string;
  routing_number: string;
  swift_code: string;
  vendor_id: string;
}

export interface EditVendor {
  profilepicture: string;
  vendor_type: string;
  first_name: string;
  last_name: string;
  mobile_number: string;
  email: string;
  street1: string;
  street2: string;
  country: string;
  state: string;
  city: string;
  zipcode: string;
  uploadId: string;
  bank_account_name: string;
  account_no: string;
  bank_name: string;
  bank_country: string;
  currency: string;
  branch_code: string;
  routing_no: string;
  swift_code: string;
  iban_no: string;
  account_type: string;
  company: string;
  vendor_type_id: string;
  company_name: string;
  company_registration_number: string;
  company_type: string;
  vat_registration: string;
  designation: string;
}
